// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SHeK","title":"styles_title__qp4A0"};